import { isElementType } from '@lumapps/wrex/slate/utils/isElementType';

import { EmbeddedMap } from '../components/blocks/EmbeddedMap';

export const isEmbeddedMap = isElementType(EmbeddedMap);
